















import Vue, { PropType } from "vue"
import datasource from "@/datasource"
import { ApiResponseWithErrors } from "@/datasource"
import type { EmailTemplate } from "@/datasource/emails"
import type { Invoice } from "@/datasource/payments"

export default Vue.extend({
  props: {
    invoice: {
      type: Object as PropType<Invoice>,
      required: true,
    },

    emailTemplate: {
      type: Object as PropType<EmailTemplate>,
      default: null,
    },

    shouldLoad: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: true,
      invoiceNotificationResponse: [] as unknown[] | Record<string, unknown>,
    }
  },

  created() {
    this.loadData()
  },

  methods: {
    async loadData() {
      this.loading = true

      if (this.shouldLoad && this.invoice.id && this.emailTemplate.id) {
        const result = await datasource.payments.sendInvoiceNotification(
          this.invoice,
          this.emailTemplate
        )

        if (result instanceof ApiResponseWithErrors) {
          const errors = result.response.errors || []
          this.invoiceNotificationResponse = errors.map((e) => e.message)
        } else if (result instanceof Error) {
          console.error(result)
          this.invoiceNotificationResponse = ["internal server error"]
        } else {
          this.$emit("saved")
          this.invoiceNotificationResponse = [result ? "Sent" : "Not sent"]
        }
      }

      this.loading = false
    },

    blur() {
      this.$emit("blur")
    },
  },
})
